import { WorkflowStepDto } from "@babackapp/private-api-client/types";
import { useEffect, useState } from "react";

export const useWorkflowModulesForms = ({
  currentFlowStep,
  onSaveTrigger,
  onSaveAction,
}: {
  currentFlowStep: WorkflowStepDto;
  onSaveTrigger: (flowStep: WorkflowStepDto) => void;
  onSaveAction: (flowStep: WorkflowStepDto) => void;
}) => {
  const [flowStep, setFlowStep] = useState<WorkflowStepDto>(currentFlowStep);
  useEffect(() => {
    setFlowStep(currentFlowStep);
  }, [currentFlowStep]);

  const workFlowInputOnChangeTitle = (value: string) => {
    const step = { ...flowStep };
    step.parameters.mail = {
      subject: value,
      body: step.parameters.mail?.body || "",
      recipients: step.parameters.mail?.recipients || [],
    };

    setFlowStep(step);
  };

  const extractWorkflowMailBody = (): string | undefined =>
    flowStep.parameters.mail?.body || "";

  const workflowInputtextOnChangeArea = (value: string) => {
    const step = { ...flowStep };

    step.parameters.mail = {
      subject: step.parameters.mail?.subject || "",
      body: value,
      recipients: step.parameters.mail?.recipients || [],
    };

    setFlowStep(step);
  };

  const onSaveUpdates = (flowType: string) => {
    if (flowType == "TRIGGER") onSaveTrigger(flowStep);
    onSaveAction(flowStep);
  };

  const onUpdateTags = (tag: string) => {
    const step = { ...flowStep };
    step.parameters.users = [];
    if (flowStep.parameters.tags && flowStep.parameters.tags.includes(tag)) {
      // Todo: fix this
      step.parameters.tags;
      setFlowStep(step);
    } else {
      if (step.parameters.tags) {
        // Todo: fix this
        // step.parameters.tags?.push(tag);
      } else {
        // Todo: fix this
        // step.parameters.tags = [tag];
      }
      setFlowStep(step);
    }
  };

  return {
    flowStep,
    workFlowInputOnChangeTitle,
    extractWorkflowMailBody,
    workflowInputtextOnChangeArea,
    onSaveUpdates,
    setFlowStep,
    onUpdateTags,
  };
};
